import React from 'react'
import type { FC, HTMLAttributes } from 'react'
import { Paper } from '../primitives/index.js'
import cn from 'classnames'
import styles from './hotkey.module.css'

interface HotkeyProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  elevation?: number
  children: React.ReactNode
}

export const Hotkey: FC<HotkeyProps> = props => {
  const { elevation = 1, children, className } = props

  return (
    <Paper className={cn(styles.paper, className)} elevation={elevation}>
      <div className={styles.content}>
        {children}
      </div>
    </Paper>
  )
}

export default Hotkey
